import PurchaseMethodsModel from 'commons-vehicle/PurchaseMethods/models/PurchaseMethodsModel.js';
import * as purchaseMethodsTypes from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActionTypes.js';
import * as PurchaseMethodsService from 'commons-vehicle/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js';

export default function purchaseMethodReducer(state = new PurchaseMethodsModel(), action) {
    switch (action.type) {
        case purchaseMethodsTypes.LOAD_PURCHASE_METHODS_SUCCESS:
            return action.purchaseMethods || state;

        case purchaseMethodsTypes.SELECT_PURCHASE_METHOD:
            return PurchaseMethodsService.selectPurchaseMethod(state, action.purchaseMethod);

        case purchaseMethodsTypes.SELECT_TERM:
            return PurchaseMethodsService.selectTerm(state, action.term);

        case purchaseMethodsTypes.SELECT_PAYMENT_FREQUENCY:
            return PurchaseMethodsService.selectPaymentFrequency(state, action.paymentFrequency.value);

        case purchaseMethodsTypes.SET_CASH_DOWN:
            return PurchaseMethodsService.setCashDown(state, action.cashDown);

        case purchaseMethodsTypes.SET_TRADE_IN:
            return PurchaseMethodsService.setTradeIn(state, action.tradeIn);

        case purchaseMethodsTypes.SET_LIEN:
            return PurchaseMethodsService.setLien(state, action.lien);

        case purchaseMethodsTypes.SET_EXTERIOR_COLOUR_AMOUNTS:
            return PurchaseMethodsService.setExteriorColourAmounts(state, action.exteriorColourAmounts);

        case purchaseMethodsTypes.SET_INTERIOR_COLOUR_AMOUNTS:
            return PurchaseMethodsService.setInteriorColourAmounts(state, action.interiorColourAmounts);

        case purchaseMethodsTypes.SET_OPTIONS_AMOUNTS:
            return PurchaseMethodsService.setOptionsAmounts(state, action.optionsAmounts);

        case purchaseMethodsTypes.SET_DELIVERY_FEE:
            return PurchaseMethodsService.setDeliveryFee(state, action.addFee);

        case purchaseMethodsTypes.SET_DEPOSIT:
            return PurchaseMethodsService.setDeposit(state, action.deposit);

        case purchaseMethodsTypes.SET_TAXES_INCLUDED:
            return PurchaseMethodsService.setTaxesIncluded(state, action.taxesIncluded);

        case purchaseMethodsTypes.SELECT_KM_PLAN:
            return PurchaseMethodsService.selectKMPlan(state, action.kmPlan.value);

        case purchaseMethodsTypes.SELECT_OPTIONS_RESOLUTION:
            return PurchaseMethodsService.selectOptionsResolution(state, action.resolutionId);

        case purchaseMethodsTypes.RESET_SELECTED_INCENTIVE_REBATES:
            return PurchaseMethodsService.resetSelectedIncentiveRebates(state);

        default:
            return state;
    }
}
